import React from 'react';
import styled from 'styled-components';
import CloseIcon from 'web-ui-kit/assets/CloseIcon';
import { ProductCardReferrer } from 'web-ui-kit/cards/ProductCard';
import { productLikeStatusChanged } from 'web-ui-kit/cards/ProductCardEvents';
import { surfaceM } from 'web-ui-kit/colors';
import { useOnScreen } from 'web-ui-kit/hooks';
import LikeDislikeButtons from 'web-ui-kit/LikeDislikeButtons';
import NavButton from 'web-ui-kit/buttons/NavButton';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
/**
 * The modal product details view.
 */


function NavOneColumn(_ref) {
  var _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$mqTwoColumnUp = _ref.mqTwoColumnUp,
      mqTwoColumnUp = _ref$mqTwoColumnUp === void 0 ? '' : _ref$mqTwoColumnUp,
      _ref$onBackNavButtonC = _ref.onBackNavButtonClick,
      onBackNavButtonClick = _ref$onBackNavButtonC === void 0 ? function () {} : _ref$onBackNavButtonC,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$productDetailsSt = _ref.productDetailsState,
      productDetailsState = _ref$productDetailsSt === void 0 ? {} : _ref$productDetailsSt,
      _ref$productImageEl = _ref.productImageEl,
      productImageEl = _ref$productImageEl === void 0 ? null : _ref$productImageEl;
  var isProductImageVisible = useOnScreen({
    targetEl: productImageEl,
    initialValue: true
  });
  var product = productDetailsState.product || {};
  var _product$id = product.id,
      id = _product$id === void 0 ? '' : _product$id,
      _product$liked = product.liked,
      liked = _product$liked === void 0 ? false : _product$liked;
  var dislikeButtonConfig = productDetailsState.dislikeButtonConfig,
      isAltProduct = productDetailsState.isAltProduct,
      parentProductId = productDetailsState.parentProductId;

  var handleLikeDislikeChange = function handleLikeDislikeChange(event) {
    dispatch(productLikeStatusChanged({
      event: event,
      parentProductId: parentProductId,
      productId: id,
      product: product,
      referrer: ProductCardReferrer.PDP
    }));
  };

  var BackNavButton = styles.BackNavButton,
      Container = styles.Container,
      LeftButtons = styles.LeftButtons,
      ProductLikeDislikeButtons = styles.ProductLikeDislikeButtons,
      XoutContainerOneColumn = styles.XoutContainerOneColumn;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "one-column-nav-".concat(isProductImageVisible ? 'floating' : 'navbar'),
      mqTwoColumnUp: mqTwoColumnUp,
      isProductImageVisible: isProductImageVisible
    },
    /*#__PURE__*/
    React.createElement(LeftButtons, null, isAltProduct &&
    /*#__PURE__*/
    React.createElement(BackNavButton, {
      ariaLabel: "previous product",
      isProductImageVisible: isProductImageVisible,
      onClick: onBackNavButtonClick,
      variant: "back"
    }),
    /*#__PURE__*/
    React.createElement(XoutContainerOneColumn, {
      onClick: onClose,
      isProductImageVisible: isProductImageVisible
    },
    /*#__PURE__*/
    React.createElement(CloseIcon, null))),
    /*#__PURE__*/
    React.createElement(ProductLikeDislikeButtons, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: handleLikeDislikeChange,
      isDisliked: liked < 0,
      isLiked: liked > 0,
      isProductImageVisible: isProductImageVisible
    }))
  );
}

var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n\n    display: flex;\n    justify-content: space-between;\n    padding: 0.5rem 1rem;\n\n    /** Hide the 1 column nav when view is two column */\n    ", " {\n      display: none;\n    }\n\n    /** When the product image is not visible, apply background styles */\n    ", "\n  "])), function (p) {
    return p.mqTwoColumnUp;
  }, function (p) {
    return !p.isProductImageVisible && "\n      background-color: ".concat(surfaceM, ";\n    ");
  }),
  LeftButtons: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n  "]))),
  BackNavButton: styled(NavButton)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border-radius: 4px;\n    box-shadow: none;\n    margin-right: 0.5rem;\n\n    /** When the product image is visible, apply drop shadow styles */\n    ", "\n  "])), function (p) {
    return p.isProductImageVisible && "\n      filter: drop-shadow(0px 2px 4px rgba(65, 67, 74, 0.15));\n    ";
  }),
  XoutContainerOneColumn: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    height: 2rem;\n    width: 2rem;\n\n    background-color: ", ";\n    border-radius: 4px;\n\n    /** When the product image is visible, apply drop shadow styles */\n    ", "\n  "])), surfaceM, function (p) {
    return p.isProductImageVisible && "\n      filter: drop-shadow(0px 2px 4px rgba(65, 67, 74, 0.15));\n    ";
  }),
  ProductLikeDislikeButtons: styled(LikeDislikeButtons)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    /** When the product image is visible, apply drop shadow styles */\n    ", "\n  "])), function (p) {
    return p.isProductImageVisible && "\n      filter: drop-shadow(0px 2px 4px rgba(65, 67, 74, 0.15));\n    ";
  })
};
export default NavOneColumn;